import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const toDetail = listeners["toDetail"] || function () { };

  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    if (vo.row.myAuditStatus == 1) {
      dealConf.push([
        "icon-audit",
        "审核",
        () => {
          toDetail(vo.row, '审核');
        },
        "topicLecture:learn:specialBatchAudit"
      ]);
    } else {
      dealConf.push([
        "icon-audit-detail",
        "审核详情",
        () => {
          toDetail(vo.row, '审核详情');
        },
        "topicLecture:queryLearnDeclare"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  function selectable(row, index) {
    if (row.myAuditStatus == 1) {
      return true
    }
    return false
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      selectable: selectable
    },
    {
      label: "姓名",
      prop: "userName",
      width: "110"
    },
    {
      label: "工作单位",
      prop: "deptName",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      width: "150"
    },
    {
      label: "学习名称",
      prop: "lectureName",
      minWidth: "140",
    }, 
    {
      label: "学习时间",
      prop: "learnDate",
      minWidth: "120",
      // sortable: true
    }, {
      label: "学时",
      prop: "lectureHours",
      minWidth: "80",
    }, {
      label: "学习单位",
      prop: "organizer",
      minWidth: "120",
      //showOverflowTooltip: true
    },
    {
      label: "学习地点",
      prop: "lecturePlace",
      minWidth: "120",
      // showOverflowTooltip: true
    },
    {
      label: "我的审核状态",
      prop: "myAuditStatusStr",
      width: "100",
    },
    {
      label: "申报审核状态",
      prop: "auditStatusStr",
      width: "100",
    },
    {
      label: "申报时间",
      prop: "createDate",
      minWidth: "130",
      // sortable: true
    },
    {
      label: "操作",
      fixed: "right",
      with: "40",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};
export default Table;
